export const LOGIN_TYPE_ACCOUNT = "ACCOUNT_PWD";
export const LOGIN_TYPE_PHONE = "PHONE_PWD";
export const LOGIN_TYPE_EMAIL = "EMAIL_PWD";
export const LOGIN_TYPE_CERT = "CERT_PWD";
export const LOGIN_TYPE_PHONE_CODE = "PHONE_CODE";
export const LOGIN_TYPE_EMAIL_CODE = "EMAIL_CODE";
export const LOGIN_TYPE_DESKTOP_QUICK = "ONE_CLICK";
export const LOGIN_TYPE_UNION_PHONE = "ACCOUNT_PWD_CODE";
export const LOGIN_TYPE_UNION_EMAIL = "ACCOUNT_PWD_EMAIL_CODE";
export const LOGIN_TYPE_THIRD_APPLE = "THIRD_APPLE";
export const LOGIN_TYPE_THIRD_WECHAT = "THIRD_WECHAT";
export const LOGIN_TYPE_THIRD_WECHAT_QR = "THIRD_WECHAT_QR";


export function checkUnionEnable(types) {
  return types.includes(LOGIN_TYPE_UNION_PHONE)
      || types.includes(LOGIN_TYPE_UNION_EMAIL);
}

export function checkPwdEnable(types) {
  return types.includes(LOGIN_TYPE_ACCOUNT)
      || types.includes(LOGIN_TYPE_PHONE)
      || types.includes(LOGIN_TYPE_EMAIL)
      || types.includes(LOGIN_TYPE_CERT);
}

export function checkCodeEnable(types) {
  return types.includes(LOGIN_TYPE_PHONE_CODE)
      || types.includes(LOGIN_TYPE_EMAIL_CODE);
}

export function checkThirdEnable(types) {
  return types.includes(LOGIN_TYPE_THIRD_APPLE)
      || types.includes(LOGIN_TYPE_THIRD_WECHAT)
      || types.includes(LOGIN_TYPE_THIRD_WECHAT_QR);
}
